import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input, OnChanges,
    OnInit,
    Output, SimpleChanges,
    ViewEncapsulation
} from '@angular/core';
import {ContextMenuAction, GenericItem} from '@emm/core/models/context-menu-action.model';
import {BehaviorSubject, Observable} from 'rxjs';
import {SharedFacadeService} from '@emm/shared/services/shared-facade.service';
import {map} from 'rxjs/operators';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'emm-generic-items-list',
    styleUrls: ['./generic-items-list.component.scss'],
    templateUrl: './generic-items-list.component.html'
})
export class GenericItemsListComponent implements OnInit {
    items$ = new BehaviorSubject<GenericItem<any>[]>([]);

    @Input() contextMenuActions: ContextMenuAction<any>[];
    @Input() disableContextActions: boolean;
    @Input()
    set items(value: GenericItem<any>[]) {
        this.items$.next(value);
    }
    @Input() isReadOnly: boolean;
    @Input() selectedItem: GenericItem<any>;
    @Input() changeOnSelect = true;

    @Output() onSelectItem = new EventEmitter<any>();

    showTags$: Observable<boolean>;

    constructor(private sharedFacadeService: SharedFacadeService) {}

    ngOnInit(): void {
        this.showTags$ = this.sharedFacadeService.showTags$.pipe(
            map(showTags => showTags === 'true')
        );
    }

    onItemSelected(item: any) {
        this.onSelectItem.emit(item);
        if (this.changeOnSelect) {
            this.selectedItem = item;
        }
    }

}
